import moment from "moment";
import { useCallback, useState } from "react";

import { QuestionnaireReport } from "../../api/QuestionnaireReport";
import { IFormQuestionnaireReport } from "../../interfaces/IFormQuestionnaireReport";

interface Return {
  data: {
    loadingActive: boolean;
  };
  method: {
    exportReport(values: IFormQuestionnaireReport): void;
  };
}

export default function useViewModel(): Return {
  const [loadingActive, setLoadingActive] = useState(false);

  const exportReport = useCallback(
    async (values: IFormQuestionnaireReport) => {
      const today = moment(new Date()).format("yyyyMMDD");
      setLoadingActive(true);
      await QuestionnaireReport(values.startDate, values.endDate)
        .then((res) => {
          const downloadLink = document.createElement("a");
          const linkSource = `data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${res.data.fileBase64}`;
          downloadLink.href = linkSource;
          downloadLink.download = `QuestionnaireReportALESA_${today}.xlsx`;
          downloadLink.click();
          setLoadingActive(false);
        })
        .catch((error) => {
          console.log("Error fetching data:", error);
          setLoadingActive(false);
        });
    },
    [QuestionnaireReport]
  );

  return {
    data: {
      loadingActive,
    },
    method: {
      exportReport,
    },
  };
}
